import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const ToastEl = styled.div`
  position: fixed;
  left: 50%;
  bottom: 28px;
  transform: translateX(-50%) ${p => (p.$show ? 'translateY(0)' : 'translateY(20px)')};
  background: ${p => p.theme.colors.black};
  color: #fff;
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  box-shadow: ${p => p.theme.colors.semantic.shadowLg};
  opacity: ${p => (p.$show ? 1 : 0)};
  pointer-events: none;
  transition: all 0.25s;
  z-index: 200;
  display: flex;
  align-items: center;
  gap: 8px;
`

const Dot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${p => p.theme.colors.semantic.success};
`

const WipAiToast = ({ message = null, show }) => (
  <ToastEl $show={show && !!message} aria-live="polite">
    {show && message ? (
      <>
        <Dot />
        <span>{message}</span>
      </>
    ) : null}
  </ToastEl>
)

WipAiToast.propTypes = {
  message: PropTypes.string,
  show: PropTypes.bool.isRequired,
}

export default WipAiToast
